const staffList = [
	{ userName: "Susan", email: "susan@castlemilkpantry.co.uk", role: "admin", userImage: "../../../../public/assets/images/avatars/avatar_1.jpg" },
	{ userName: "Fiona", email: "fiona@castlemilkpantry.co.uk", role: "admin", userImage: "../../../../public/assets/images/avatars/avatar_23.jpg"   },
	{ userName: "Volunteers", email: "volunteers@castlemilkpantry.co.uk", role: "assistant", userImage: "../../../../public/assets/images/avatars/avatar_16.jpg"   },
];

export default staffList;